import React, {createContext} from 'react';

export const MusicPlayAssignCtx = createContext({
  trackId: null as string | number | null,
  setTrackId: ((val: string | number | null) => {
    return val;
  }) as React.Dispatch<React.SetStateAction<string | number | null>>,
});
export const useMusicPlayAssignCtx = () => React.useContext(MusicPlayAssignCtx);
